import {
    InjectionToken,
    NgZone,
} from '@angular/core';

import {
    Observable,
    ReplaySubject,
} from 'rxjs';
import {
    switchMap,
    take,
} from 'rxjs/operators';

export const COLOR_PROVIDER = new InjectionToken<ColorProvider>('Chart Color Provider');

export abstract class ColorProvider {
    public abstract textColor: string;
    public abstract tooltipTextColor: string;
    public abstract tooltipBackgroundColor: string;
    public abstract legendTextColor: string;
    public abstract legendInactiveColor: string;
    public abstract axisTextColor: string;
    public abstract axisLineColor: string;
    public abstract gridLineColor: string;
    public abstract axisHoverColor: string;

    public changes$: Observable<any>;

    protected _changes = new ReplaySubject(1);

    constructor(zone: NgZone) {
        this.changes$ = this._changes.pipe(
            switchMap(() => zone.onStable.pipe(take(1))),
        );
        this._changes.next();
    }

    destroy() {
        this._changes.complete();
    }
}

export class DefaultColorProvider extends ColorProvider {
    public textColor = '#121212';
    public tooltipTextColor = '#121212';
    public tooltipBackgroundColor = 'white';
    public legendTextColor = '#121212';
    public legendInactiveColor = '#ccc';
    public axisTextColor = '#121212';
    public axisLineColor = '#121212';
    public gridLineColor = '#ddd';
    public axisHoverColor = 'rgba(0, 0, 0, .1)';
}
